import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { AuthStore } from "./core/auth/persistence/auth.store";
import { NavComponent } from "./core/layout/components/nav/nav.component";
import { SpinnerService } from "./core/spinner/spinner.service";
import { RegionService } from "./core/regions/region.service";

@Component({
    selector: "app-root",
    imports: [RouterOutlet, NavComponent],
    templateUrl: "./app.component.html",
})
export class AppComponent {
    public authStore = inject(AuthStore);
    public regionService = inject(RegionService);
    public spinnerService = inject(SpinnerService);
}
